import React from 'react';
import cn from 'classnames';

interface Props {
  topBorder?: boolean;
}

const Section: React.FC<Props> = ({ topBorder = true, children }) => (
  <div
    className={cn(
      'container jg-space-phms@md jg-space-mvms',
      {
        'jg-bdt jg-bd--very-light-grey jg-bdn@md': topBorder,
      },
      'jg-space-mbml@md'
    )}
  >
    {children}
  </div>
);
export default Section;
